const LoginBg = () => {
  return (
    <div
      className="font-darker h-dvh w-screen px-4 pt-6 text-white"
      style={{
        background:
          "linear-gradient(0deg, rgba(203, 156, 224, 0.61) 0%, rgba(203, 156, 224, 0.61) 100%), linear-gradient(11deg, #1F1633 5.95%, #342C47 102.98%)",
      }}
    >
      <h1 className="pr-12 text-[40px] leading-12 font-extrabold md:text-7xl">
        The New Standard of Digital Finance.
      </h1>
      <p className="mt-4 text-xl font-semibold md:text-3xl">
        Easily create virtual cards to handle every online purchase, bill, and
        subscription.
      </p>

      <img
        src="/images/login-icon-set.webp"
        className="absolute right-6 bottom-1/4 mt-6 max-w-[133px] w-full md:w-40"
        alt=""
      />

      <img
        className="absolute top-1/2 left-1/2 z-10 w-4/5 min-w-80 -translate-x-1/2 -translate-y-1/2 md:w-[600px]"
        src="/images/login-atm.webp"
        alt="Atm cards"
      />

      <img
        src="/images/login-bg-line.svg"
        alt=""
        className="absolute inset-x-0 bottom-0 -left-12 z-0 w-full"
      />
    </div>
  );
};

export default LoginBg;
